export var MemoizationCapture;
(function (MemoizationCapture) {
    MemoizationCapture[MemoizationCapture["OPTIMAL"] = 0] = "OPTIMAL";
    MemoizationCapture[MemoizationCapture["FULL"] = 1] = "FULL";
})(MemoizationCapture || (MemoizationCapture = {}));
/**
 * Static class of the regression capture states.
 */
export class RegressionCaptureState {
}
RegressionCaptureState.memoization = MemoizationCapture.OPTIMAL;
